import { ajaxPostJson, ajaxGetJson, setParams } from './ajax';

// 查询团队列表
export const querySelfUserList = (params) => {
  return ajaxPostJson(`/companyUser/querySelfUserList`, params);
};

// 分页查询文件下任务
export const queryPageByFileId = (params) => {
  params = {
    filter: setParams(params.filter),
    page: params.page,
    rows: params.rows
  };
  return ajaxPostJson(`/fileTask/queryPageByFileId`, params);
};

// 重新拆分
export const reSplitTask = (params) => {
  return ajaxPostJson(`/fileTask/reSplitTask`, params);
};

// 合并
export const mergeTask = (params) => {
  return ajaxPostJson(`/fileTask/mergeTask`, params);
};

// 拆分任务
export const splitTask = (params) => {
  return ajaxPostJson(`/fileTask/splitTask`, params);
};

// 拆分预览
export const splitTaskPreView = (params) => {
  return ajaxPostJson(`/fileTask/splitTaskPreView`, params);
};

// 预览按钮
export const splitTaskPreViewDetail = (params) => {
  return ajaxPostJson(`/fileTask/splitTaskPreViewDetail`, params);
};

// 分配任务
export const assignTask = (params) => {
  return ajaxPostJson(`/fileTask/assignTask`, params);
};

// 查询三种任务的个数
export const fileTaskNum = (params) => {
  return ajaxPostJson(`/fileTask/fileIdToTaskClassificationNum`, params);
};

// 查询已分配未分配已完成未完成数量
export const getTransFileTaskCountNum = (params) => {
  return ajaxPostJson(`/fileTask/transFileTaskCountNum`, params);
}

// 上传答案
export const uploadAnswer = (params) => {
  return ajaxPostJson(`/file/file_answer_handler`, params);
}

// 评测结果
export const getEvaluateResult = (params) => {
  return ajaxPostJson(`/fileTask/taskScoreBySent`, params);
}

// 分配任务后更改时间
export const updateTaskTime = (params) => {
  return ajaxPostJson(`/fileTask/task_update`, params);
}

// 下载分段任务
export const downloadAsyncTask = (params) => {
  params = setParams(params);
  return ajaxPostJson(`/file/downloadAsyncTask?`, params);
}

// 轮询接口
export const getDownloadAsyncResult = (params) => {
  params = setParams(params);
  return ajaxGetJson(`/file/getDownloadAsyncResult?taskKey=${params.taskKey}&platformType=${params.platformType}&companyCode=${params.companyCode}`, params);
}
